import { Injectable, inject } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patchState } from '../../nested-value-getter';
import { CompaniesFirestoreService } from '../../services/company.firestore.service';
import { CompanyActions } from './company.action';
import { CompanyStateModel } from './company.store';

@State<CompanyStateModel>({
  name: 'companies',
  defaults: {
    companies: [],
    isLoading: false,
    filter: undefined,
  },
})
@Injectable()
export class CompanyState {
  private companyService = inject(CompaniesFirestoreService);

  @Action(CompanyActions.GetAllCompany)
  async getAllUsers(ctx: StateContext<CompanyStateModel>) {
    ctx.patchState({ isLoading: true });
    const companies = await this.companyService.GetAll();
    ctx.patchState({ companies: companies.map(({ data, ref }) => ({ data, id: ref.id })), isLoading: false });
  }

  @Action(CompanyActions.QueryCompany)
  async queryUser(ctx: StateContext<CompanyStateModel>, { filter }: CompanyActions.QueryCompany) {
    ctx.patchState({ isLoading: true });
    const companies = await this.companyService.QueryAll(filter.query);
    ctx.patchState({ companies: companies.map(({ data, ref }) => ({ data, id: ref.id })), isLoading: false });
  }

  @Action(CompanyActions.UpdateCompanyResult)
  updateCompanyResult(ctx: StateContext<CompanyStateModel>, { data }: CompanyActions.UpdateCompanyResult) {
    patchState<CompanyStateModel>(ctx, 'companies', data);
  }

  @Selector()
  static companies(state: CompanyStateModel) {
    return state.companies.map((x) => x.data);
  }

  @Selector()
  static companyState(state: CompanyStateModel) {
    return state;
  }
}
